import { render, staticRenderFns } from "./TaskMaterialModal.vue?vue&type=template&id=2d764e90&"
import script from "./TaskMaterialModal.vue?vue&type=script&lang=js&"
export * from "./TaskMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports